// extracted by mini-css-extract-plugin
export var activeTab = "e_bl_c6";
export var cardContainer = "e_bl_c2";
export var knowledge = "e_bl_c7";
export var layoutContainer = "e_bl_8";
export var screenLaptop = "1024px";
export var sectionContainer = "e_bl_9";
export var tabsWrapper = "e_bl_c5";